import React from 'react';
import { Hero } from './components/Hero';
import { TopicNav } from './components/TopicNav';
import { KeyInfo } from './components/KeyInfo';
import { FederalRegsOverview } from './components/FederalRegsOverview';
import { FederalRegulations } from './components/FederalRegulations';
import { DriverQualifications } from './components/DriverQualifications';
import { CargoTable } from './components/CargoTable';
import { ResourceLinks } from './components/ResourceLinks';
import { Disclaimers } from './components/Disclaimers';
import { FinalCTA } from './components/FinalCTA';
import { StickyCTAs } from './components/StickyCTAs';
export function App() {
  return <main className="min-h-screen bg-white pb-20 md:pb-0" data-id="element-0">
      {/*
              Note: The user requested ONLY the main content area between the H1 and the bottom accordion.
              Header and Footer are intentionally omitted per instructions.
            */}

      <Hero data-id="element-1" />
      <TopicNav data-id="element-2" />
      <KeyInfo data-id="element-3" />
      <FederalRegsOverview data-id="element-4" />
      <FederalRegulations data-id="element-5" />
      <DriverQualifications data-id="element-6" />
      <CargoTable data-id="element-7" />
      <ResourceLinks data-id="element-8" />
      <Disclaimers data-id="element-9" />
      <FinalCTA data-id="element-10" />

      <StickyCTAs data-id="element-11" />
    </main>;
}